import React from 'react';

export default function RemoveIcon(props) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      style={{ enableBackground: 'new 0 0 24 24' }}
      xmlSpace="preserve"
      {...props}
    >
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html: '\n\t.st0{fill:#010101;}\n\t.st1{fill:#FFFFFF;}\n',
        }}
      />
      <circle id="XMLID_1150_" className="st0" cx={12} cy={12} r={12} />
      <polygon
        id="XMLID_2_"
        className="st1"
        points="17,7.5 16.5,7 12,11.5 7.5,7 7,7.5 11.5,12 7,16.5 7.5,17 12,12.5 16.5,17 17,16.5
      	12.5,12 "
      />
    </svg>
  );
}
